jQuery(function($) {
    // Vars //
    var $body = $('body');
    var $window = $(window);
    var $header = $('header');

    // Functions
    menuScroll();
    backToTop();
    sliderSetup();
    featureProductSliderSetup();
    contentBlockSliderSetup();
    logoSliderBlockSetup();
    gbContentSlider();
    gbFeatureHomeSliderBlock();
    propertyGallerySlider();
    relatedPostsSlider();
    testimonialSlider();
    testimonialMasonaryGrid();
    relatedPostSlider();

    // Onclick Events
    $body
        .on('click', 'a.scroll-to-top', function (e) {
            e.preventDefault();
            var $trigger = $(this);

            $("html, body").animate({ scrollTop: 0 }, 1500);
            return false;
        })
        .on('click', '.js-mobile-trigger', function (e) {
            e.preventDefault();
            var $trigger = $(this);
            // changed to apply class to all mobile triggers so I can have multiple on page
            var $mobileTriggers = $('.js-mobile-trigger');
            if ($mobileTriggers.hasClass('active')) {
                $mobileTriggers.removeClass('active');
                $body.removeClass('hamburger-menu-active');
                $body.removeClass('no-scroll');
            }
            else {
                $mobileTriggers.addClass('active');
                $body.addClass('hamburger-menu-active');
                $body.addClass('no-scroll');
            }
        })
        .on('click', '.js-footer-accordion-trigger', function (e) {
            e.preventDefault();
            var $accordion = $(this).closest('.footer-accordion');
            var $accordionContent = $accordion.find('.footer-accordion__content');
            if ($accordion.hasClass('active')) {
                $accordion.removeClass('active');
                $accordionContent.slideUp(350);
            } else {
                $accordion.addClass('active');
                $accordionContent.slideDown(350);
            }
        })
        .on('click', '.js-accordion-trigger', function (e) {
            e.preventDefault();
            var $accordion = $(this).closest('.accordion');
            var $accordionContent = jQuery($accordion).find('.accordion__content');
            if ($accordion.hasClass('open')) {
                $accordion.removeClass('open');
                $accordionContent.slideUp();
            } else {
                $accordion.addClass('open');
                $accordionContent.slideDown();
            }
        })
        .on('click', '.menu-item-dropdown-toggle', function(e) {
            e.preventDefault();
            var $trigger = $(this);
            // $navInner = $trigger.closest('.primary-navigation__mobile-navigation--inner');
            $navItem = $trigger.closest('.nav-list__item');

            // $navInner.addClass('active');
            $navItem.addClass('active-dropdown');
        })
        .on('click', '.dropdown-back-btn', function(e) {
            e.preventDefault();
            var $trigger = $(this);
            $navInner = $trigger.closest('.primary-navigation__mobile-navigation--inner');
            $navItem  = $trigger.closest('.nav-list__item');

            $navInner.removeClass('active');
            $navItem.removeClass('active-dropdown');
        })
        .on('click', 'button.tab', function(e) {
            e.preventDefault();
            $trigger = $(this);

            $tabID = $trigger.attr('data-tab-id');
            $tabsWrapper = $trigger.closest('.form-block__tabs');
            $tab = $tabsWrapper.find('button.tab');
            $tabBlock = $tabsWrapper.closest('.form-block');
            $tabContentWrapper = $tabBlock.find('.form-block__forms');
            $tabContent = $tabContentWrapper.find('.tab-content');

            if( !($trigger.hasClass('active')) ) {
                $tab.removeClass('active');
                $tabContent.removeClass('active');

                $trigger.addClass('active');
                $tabContentWrapper.find('.tab-content#' + $tabID).addClass('active');
            }
        })
        .on('click', 'a.js-anchor-scroll', function(e) {
            $this = $(this);
            $anchorID = $this.attr('href');

            console.log($anchorID);

            $('html, body').animate({
                scrollTop: $($anchorID).offset().top - 100
            }, 1500);
        })
    ;

    // Fancy Box
    // $('[data-fancybox="gallery"]').fancybox({
    //     buttons: [
    //         "slideShow",
    //         "close"
    //     ]
    // });

    // Kadence  Blocks - WP Plugin - Tabs Block 
    // jQuery([document.documentElement, document.body]).animate({
    //     scrollTop: jQuery( '.wp-block-kadence-tabs' ).closest( '.kt-tabs-wrap' ).find( '.kt-tabs-content-wrap > .kt-tabs-accordion-title' ).offset().top + 20
    // }, 600);

    //because we are taking over the display of tabs we need to hide all tabs on load, then make active the "active" tab and set our class
    $('.wp-block-kadence-tab:not(.active)').hide();

    $('.wp-block-kadence-tabs').each(function(e) {
        $tabs = $(this).find('.kt-title-item');
        $activeTab = $(this).find('.kt-tab-title-active');
        activeTabIndex = $tabs.index($activeTab) + 1;

        $(this).find('.wp-block-kadence-tab:nth-child('+activeTabIndex+')').show().addClass('active-tab');
    });

    // handles the click of any tab titles
    $('.wp-block-kadence-tabs').on('click', '.kt-tab-title', function(e) {
        e.preventDefault();
        $clickedTabTitle = $(this);
        $clickedParentItem = $clickedTabTitle.closest('.kt-title-item');
        $parentTitleListSlider = $clickedTabTitle.closest('.kt-tabs-title-list.slick-slider');
        $parentTabBlock = $clickedTabTitle.closest('.wp-block-kadence-tabs');
        clickedTabTarget = $clickedTabTitle.attr('href').replace('#', '');
        
        // handle tab title classes
        $parentTabBlock.find(".kt-tab-title-active").removeClass('kt-tab-title-active');
        $clickedParentItem.addClass('kt-tab-title-active');

        // handle tab content classes/animation
        $parentTabBlock.find(".wp-block-kadence-tab.active-tab").fadeOut(400, function() {
            $(this).removeClass('active-tab');
            $parentTabBlock.find(".wp-block-kadence-tab[aria-labelledby='"+clickedTabTarget+"']").addClass('active-tab').fadeIn();
        });

        // handle slider (make sure the current slide is the clicked tab)
        if($parentTitleListSlider.length > 0) {
            indexOfClicked = $parentTitleListSlider.find('.kt-title-item').index($clickedParentItem);
            $parentTitleListSlider.slick('slickGoTo', indexOfClicked);
        }
    });

    // Resize Functions //
    var resizeThreshold;
    $(window).on('resize', function () {
        if (resizeThreshold) {
            clearTimeout(resizeThreshold);
        }

        resizeThreshold = setTimeout(function () {
            setTimeout(function () {
                backToTop();
                sliderSetup();
                featureProductSliderSetup();
                contentBlockSliderSetup();
                logoSliderBlockSetup();
                gbContentSlider();
                gbFeatureHomeSliderBlock();
                propertyGallerySlider();
                relatedPostsSlider();
                testimonialSlider();
                testimonialMasonaryGrid();
                relatedPostSlider();
            }, 100);
        }, 200);
    });
});

